module.exports = __webpack_public_path__ + "img/6.93d637e2.gif";